import _ from 'lodash';

import contact1Img from "./images/contact1.jpeg";
import contact2Img from "./images/contact2.jpeg";
import {getOriginLink} from "../../utils/constants";

export const PRODUCT_CATEGORY_ICONS = {
  'Immobilie': 'fa-building',
  'Wohnimmobilie': 'fa-house-user',
  'Büroimmobilie': 'fa-city',
  'Gewerbe/Großhandelsimmobilie': 'fa-warehouse',
  'Hotels': 'fa-hotel',
  'Pflegeeinrichtungen': 'fa-procedures',
  'Infrastruktur': 'fa-network-wired',
  'Brücken': 'fa-road',
  'Baugewerbe': 'fa-hard-hat',
  'Häfen': 'fa-anchor',
  'Bahnhöfe': 'fa-train',
  'Logistik': 'fa-truck-moving',
  'Container': 'fa-boxes',
  'Transport': 'fa-shipping-fast',
  'Wechselkoffer': 'fa-box',
  'Windräder': 'fa-wind',
  'Solarparks': 'fa-solar-panel',
  'Biotechnologie': 'fa-dna',
  'Chips': 'fa-microchip',
  'Technologie': 'fa-cogs',
  'Umwelttechnik': 'fa-leaf',
  'Medizintechnik': 'fa-heartbeat',
  'Digital Health': 'fa-laptop-medical',
  'Automatisierungstechnik': 'fa-robot',
  'Robotic': 'fa-robot'
};

export const WALNUT_LOGIN_OPTIONS = [
  {id: 1, value: 'https://login.walnut.live/bca', label: 'Walnut für BCA/VVS-Partner'},
  {id: 2, value: 'https://login.walnut.live/carat', label: 'Walnut für CARAT-Partner'},
  {id: 3, value: 'https://login.walnut.live/bfv', label: 'Walnut für BfV-Partner'},
];

const BCA_TENANT = 'BCA';
const CARAT_TENANT = 'CARAT';
const BFV_TENANT = 'BfV';
const TENANTS_DOMAINS = {
  'bca.de': BCA_TENANT,
  'carat-ag.de': CARAT_TENANT,
  'bfv-ag.de': BFV_TENANT,
  'bca-vvs.de': 'VVS',
  'ovb.diva-app.de': 'OVB'
};

const CONTACT_1_TENANT_EMAILS = {
  [BCA_TENANT]: 'sachwerte@bca.de',
  [CARAT_TENANT]: 'sachwerte@carat-ag.de',
  [BFV_TENANT]: 'sachwerte@bfv-ag.de'
};

export const CONTACT_1_INFO = {
  name: 'Steve Ahlborn',
  role: 'Sachwertexperte BCA-Konzern',
  getEmail: () => CONTACT_1_TENANT_EMAILS[getTenant()] || CONTACT_1_TENANT_EMAILS[BCA_TENANT],
  phone: '06171/9150-615',
  mobile: '0178/7807975',
  image: contact1Img,
};

export const CONTACT_2_INFO = {
  name: 'Gwendolyn Vollmer',
  role: 'Sachwertexpertin IC Consulting',
  email: 'gwendolyn.vollmer@ic-rosenheim.de',
  phone: '04120/20815-71',
  mobile: '01525/4586989',
  image: contact2Img,
};

export const getTenant = () => {
  const origin = getOriginLink() || '';
  const domain = _.find(Object.keys(TENANTS_DOMAINS), (domain) => origin.endsWith(domain));

  return domain ? TENANTS_DOMAINS[domain] : BCA_TENANT;
};